import { motion } from "framer-motion"
import { useNavigate } from "react-router-dom"
import logo from "../assets/iconOnly.png"

export default function SiteMap() {

    const navigate = useNavigate()

    function NavButton({ to, children }) {
        return (
            <div className="pointer" onClick={() => navigate(to)}>
                {children}
            </div>
        )
    }

    return (
        <>
            <motion.div initial={{ opacity: 0, y: 150 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.3, delay: 0.2 }} id="site-map">
                <div className="flex row centerX">
                    <div style={{ marginRight: 10 }}>
                        <img 
                            alt="pands logo"
                            src={logo}
                            style={{
                                width: 70,
                                aspectRatio: 1
                            }}
                        />
                    </div>
                    <h1 style={{ fontSize: 40 }}>PandS Tech</h1>
                </div>
                <br />
                <br />
                <div id="site-content">
                    <div>
                        <h2>Contact Us</h2>
                        <br/>
                        <br/>
                        <p>info@pands.app</p>
                        <br/>
                        <p>Tel: +27 68 549 9070</p>
                        <br/>
                        <p>Thohoyandou, 0950</p>
                        <br/>
                        <p>Thohoyandou, South Africa</p>
                        <br/>
                        <br/>
                        <br/>
                    </div>
                    <div>
                        <h2>Navigation</h2>
                        <br/>
                        <br/>
                        <NavButton to="/">
                            <p>Home</p>
                        </NavButton>
                        <br />
                        <NavButton to="/about-us">
                            <p>About Us</p>
                        </NavButton>
                        <br/>
                        <NavButton to="/our-work">
                            <p>Our Work</p>
                        </NavButton>
                        <br/>
                        <NavButton to="/our-team">
                            <p>Our Team</p>
                        </NavButton>
                        {/* <br/>
                        <NavButton to="/terms-of-service">
                            <p>Terms Of Service</p>
                        </NavButton> */}
                        <br/>
                        <br/>
                        <br/>
                    </div>
                    <div>
                        <h2>Social</h2>
                        <br/>
                        <br/>
                        <NavButton to="/contact-us">
                            <p>Facebook</p>
                        </NavButton>
                        <br/>
                        <NavButton to="/contact-us">
                            <p>Twitter</p>
                        </NavButton>
                        <br/>
                        <NavButton to="/contact-us">
                            <p>Instagram</p>
                        </NavButton>
                        <br/>
                        <NavButton to="/contact-us">
                            <p>LinkedIn</p>
                        </NavButton>
                        <br/>
                        <br/>
                        <br/>
                    </div>
                </div>
                <br/>
                <br/>
                <br/>
                <p style={{ textAlign: 'center' }}>© 2023 by P and S Tech Solutions.</p>
                <br/>
                <br/>
                <br/>
            </motion.div>
        </>
    )
}